/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Provisioned volume settings.
*/
export class VolumeSettings {
  /**
  * Volume type.
  */
  'type': string;
  /**
  * Volume size in bytes.
  */
  'sizeBytes': number;
  /**
  * Volume IOPS.
  */
  'iops'?: number;
  /**
  * Volume throughput.
  */
  'throughput'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "type",
      "baseName": "type",
      "type": "string",
      "format": ""
    },
    {
      "name": "sizeBytes",
      "baseName": "sizeBytes",
      "type": "number",
      "format": "int64"
    },
    {
      "name": "iops",
      "baseName": "iops",
      "type": "number",
      "format": ""
    },
    {
      "name": "throughput",
      "baseName": "throughput",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VolumeSettings.attributeTypeMap;
  }

  public constructor() {
  }
}

